import { render, staticRenderFns } from "./ShopButton.vue?vue&type=template&id=45120f98&scoped=true&lang=html&"
import script from "./ShopButton.vue?vue&type=script&lang=js&"
export * from "./ShopButton.vue?vue&type=script&lang=js&"
import style0 from "./ShopButton.vue?vue&type=style&index=0&id=45120f98&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45120f98",
  null
  
)

export default component.exports